import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { Getter } from 'vuex-class';
import BcTable from '@/components/Table.vue';
// @ts-ignore
import BcSnackbar, { CBcSnackbar } from '@/components/BcSnackbar.vue';
// @ts-ignore
import BcDialog from '@/components/Dialog.vue';
let SalesOrder = class SalesOrder extends Vue {
    constructor() {
        super(...arguments);
        this.snackbar = new CBcSnackbar();
        this.searchForm = {
            keyword: '',
            displayOption: 0,
            docDates: [],
            deliveryDates: [],
            timer: null,
            orderStatus: [],
            sortBy: '',
            sortType: '',
        };
        this.orderTableOption = {
            loading: false,
            headers: [
                {
                    text: '客户名称',
                    align: 'left',
                    sortable: false,
                    value: 'customerName',
                    width: '180',
                },
                //   {
                //     text: "合同编号",
                //     align: "left",
                //     sortable: false,
                //     value: "contractNumber",
                //   },
                {
                    text: '订单编号',
                    align: 'center',
                    sortable: false,
                    value: 'orderNumber',
                    width: '150',
                },
                {
                    text: '订单类型',
                    align: 'center',
                    sortable: false,
                    value: 'orderType',
                    width: '80',
                },
                {
                    text: '制单人员',
                    align: 'left',
                    sortable: false,
                    value: 'docMaker',
                },
                {
                    text: '制单日期',
                    align: 'center',
                    sortable: true,
                    value: 'docDate',
                    width: '115',
                },
                {
                    text: '交货日期',
                    align: 'center',
                    sortable: true,
                    value: 'deliveryDate',
                    width: '115',
                },
                {
                    text: '进度总览(已入库/质检中/生产中)',
                    align: 'right',
                    sortable: false,
                    value: 'schedule',
                    width: '220',
                },
                {
                    text: '最后入库时间',
                    align: 'center',
                    sortable: false,
                    value: 'maxInboundDate',
                    width: '170',
                },
                //   {
                //     text: "研发确认",
                //     align: "center",
                //     sortable: false,
                //     value: "rdpConfirmName",
                //     width: "140",
                //   },
                //   {
                //     text: "生产确认",
                //     align: "center",
                //     sortable: false,
                //     value: "pdConfirmName",
                //     width: "140",
                //   },
                //   {
                //     text: "销售部审核",
                //     align: "center",
                //     sortable: true,
                //     value: "salesAuditor",
                //     width: "140",
                //   },
                //   {
                //     text: "总经理审批",
                //     align: "center",
                //     sortable: false,
                //     value: "gmApproval",
                //     width: "140",
                //   },
                {
                    text: '订单状态',
                    align: 'center',
                    sortable: false,
                    value: 'orderStatus',
                    width: '140',
                },
                {
                    text: '操作',
                    align: 'left',
                    sortable: false,
                    value: 'action',
                    width: '180',
                },
            ],
            desserts: [],
            pagination: {
                pageCount: 1,
                pageNow: 1,
                pageArr: [5, 10, 20, 50, '所有'],
                everyPageCount: 10,
                sumDetail: 0,
            },
        };
        this.dialogOrder = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
            products: [],
        };
        // 订单状态信息
        this.dialogStatus = {
            visible: false,
            loading: false,
            title: '',
            operType: 'confirm',
            form: false,
            formData: {},
            formOption: {},
        };
        this.dialogProduct = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
            products: [],
        };
        // 设备质检申请单
        this.dialogExamine = {
            visible: false,
            loading: false,
            title: '',
            operType: 'add',
            form: false,
            formData: {},
            products: [],
        };
        this.formLoading = false; // 表单加载
        this.listHospital = []; // 医院信息
        this.productList = []; // 产品集合
        // 初版订单状态根据确认人信息进入对应的状态，原则上是需要制单人手动提交一次才能进入下一阶段，并且下一阶段不允许修改，初版先不做限制
        this.orderStatusArray = [
            {
                value: 0,
                label: '待提交',
                color: '#607d8b',
            },
            {
                value: 1,
                label: '待研发确认',
                text: '研发确认',
                fieldName: 'rdpConfirmName',
                fieldDate: 'rdpConfirmDate',
                color: '#5cbbf6',
                isNotSearch: true,
            },
            {
                value: 2,
                label: '待生产确认',
                text: '生产确认',
                fieldName: 'pdConfirmName',
                fieldDate: 'pdConfirmDate',
                color: '#2196f3',
                isNotSearch: true,
            },
            {
                value: 3,
                label: '待销售审核',
                text: '销售审核',
                fieldName: 'salesAuditor',
                fieldDate: 'salesAuditDate',
                color: '#fb8c00',
                isNotSearch: true,
            },
            {
                value: 4,
                label: '待总经理审批',
                text: '总经理审批',
                fieldName: 'gmApproval',
                fieldDate: 'gmApprovalDate',
                color: '#44b2d2',
                isNotSearch: true,
            },
            { value: 5, label: '待生产', color: '#00897B' },
            { value: 6, label: '生产中', color: '#8BC34A' },
            { value: 7, label: '已完成', color: '#4caf50' },
            { value: 8, label: '已作废', color: '#ff5252' },
        ];
        this.operDateArray = ['deliveryDate', 'docDate', 'rdpConfirmDate', 'pdConfirmDate', 'salesAuditDate', 'gmApprovalDate'];
        this.userInfoDic = {
            list: [],
            value: undefined,
            loading: true,
        };
        this.qualityPassCount = 0; // 不通过数
    }
    get dateRangeText() {
        let str = '';
        if (this.searchForm.docDates.length > 0) {
            str = this.searchForm.docDates.join(' ~ ');
        }
        return str;
    }
    get deliveryDateRangeText() {
        let str = '';
        if (this.searchForm.deliveryDates.length > 0) {
            str = this.searchForm.deliveryDates.join(' ~ ');
        }
        return str;
    }
    getOrderStatusOption(orderStatus) {
        const that = this;
        const option = that.orderStatusArray.find((o) => o.value == orderStatus);
        return option || {};
    }
    // 医院列表
    async getHospitalList() {
        const that = this;
        // 只需要触发一次
        if ((that.listHospital || []).length > 0) {
            return;
        }
        try {
            const ret = await that.axios.get('/api/hospital', { params: { simple: true } }).then((res) => {
                that.listHospital = (res && res.data && res.data.result) || [];
                return res;
            });
            return ret;
        }
        catch (e) {
            // that.snackbar.error('数据加载失败，请尝试重新查询');
            throw e;
        }
    }
    // 产品列表
    async getProductList() {
        const that = this;
        const res = await that.axios.get('/api/erp/inventory/statistics');
        that.productList = (res.data && res.data.result) || [];
    }
    searchChange() {
        const that = this;
        clearTimeout(that.searchForm.timer);
        that.searchForm.timer = setTimeout(() => {
            that.getDataList();
        }, 300); // 1秒执行一次获取函数 防抖
    }
    async getDataList() {
        const that = this;
        that.orderTableOption.loading = true;
        try {
            const res = await that.axios.get('/api/erp/order/sales', {
                params: {
                    withProducts: true,
                    withQuality: true,
                    page: that.orderTableOption.pagination.pageNow,
                    limit: typeof that.orderTableOption.pagination.everyPageCount === 'number'
                        ? that.orderTableOption.pagination.everyPageCount
                        : that.orderTableOption.pagination.sumDetail,
                    keyword: that.searchForm.keyword,
                    hospitalId: that.searchForm.hospitalId,
                    docStartDate: (that.searchForm.docDates.length > 0 && that.searchForm.docDates[0]) || '',
                    docEndDate: (that.searchForm.docDates.length > 1 && that.searchForm.docDates[1]) || '',
                    orderType: !/全部|所有/.test(that.searchForm.orderType) ? that.searchForm.orderType : '',
                    orderStatus: (that.searchForm.orderStatus && that.searchForm.orderStatus.toString()) || '',
                    sortBy: that.searchForm.sortBy,
                    sortType: that.searchForm.sortType,
                    deliveryStartDate: (that.searchForm.deliveryDates.length > 0 && that.searchForm.deliveryDates[0]) || '',
                    deliveryEndDate: (that.searchForm.deliveryDates.length > 1 && that.searchForm.deliveryDates[1]) || '',
                },
            });
            that.orderTableOption.desserts = res.data.result || [];
            // 处理签订日期数据
            that.orderTableOption.desserts.forEach((item) => {
                for (let index = 0; index < that.operDateArray.length; index++) {
                    const key = that.operDateArray[index];
                    if (item[key])
                        item[key] = new Date(item[key]).format('yyyy-MM-dd');
                }
                // 处理设备集合
                item.proceProducts = [
                    ...item.inventoryProducts.map((e) => ({ ...e, type: 'inventory' })),
                    ...item.qualityProducts.map((e) => ({ ...e, type: 'quality' })),
                ];
            });
            that.orderTableOption.pagination.sumDetail = res.data.sum || 0;
            // 分页信息处理
            that.orderTableOption.pagination.sumDetail = res.data.sum;
            const pageCount = Math.ceil(res.data.sum / that.orderTableOption.pagination.everyPageCount) || 1;
            that.orderTableOption.pagination.pageCount = pageCount;
            if (that.orderTableOption.pagination.pageNow > pageCount) {
                that.orderTableOption.pagination.pageNow = pageCount;
                that.getDataList();
            }
        }
        catch (e) {
            console.log(e);
        }
        finally {
            that.orderTableOption.loading = false;
        }
    }
    /**
     * 显示订单表单
     */
    async showOrderFormClick(operType, row) {
        const that = this;
        // 添加
        async function addFunc() {
            that.dialogOrder.title = '新增生产申请单';
            that.dialogOrder.formData.orderType = '试用';
            // 制单人 制单日期
            that.dialogOrder.formData.docDate = new Date().format('yyyy-MM-dd');
            that.dialogOrder.formData.docMaker = (that.userInfo || {}).name; // 获取当前操作人
            await that.getProductList();
        }
        // 修改
        async function editFunc() {
            that.dialogOrder.title = '修改生产申请单信息';
            await that.getProductList();
            that.dialogOrder.products = await that.getSalesProduct({
                salesOrderId: row.id,
            });
            if (that.dialogOrder.products.length > 0) {
                that.dialogOrder.products.forEach((item) => {
                    item.productInfo = that.productList.find((o) => o.id == item.productInfoId);
                });
                console.log(that.dialogOrder.products);
            }
        }
        // 删除
        async function deleteFunc() {
            that.dialogOrder.title = '删除生产申请单';
        }
        // 开始生产
        async function beginFunc() {
            await editFunc();
            that.dialogOrder.title = '生产订单确认';
        }
        // 完成生产提交品控确认
        async function endFunc() {
            that.dialogExamine.visible = true;
            that.formLoading = true;
            that.dialogExamine.title = '提交质检申请确认';
            that.dialogExamine.formData.applicant = (that.userInfo || {}).name;
            that.dialogExamine.formData.applicationDate = new Date().format('yyyy-MM-dd');
            that.dialogExamine.formData.remark = `生产订单${row.orderNumber}批量提交质检申请`;
            that.dialogExamine.formData.salesOrderId = row.id; // 订单id
            that.dialogExamine.formData.salesOrderNumber = row.orderNumber; // 订单编号
            that.dialogExamine.formData.salesOrderType = row.orderType; // 订单类型 销售/生产/研发
            that.dialogExamine.formData.dataSource = 0; // 数据来源0-生产 1-退库
            that.dialogExamine.formData.salesOrderRemark = row.remark; // 生产订单备注
            that.dialogExamine.formData.deviceCount = row.deviceCount;
            that.dialogExamine.formData.inventoryCount = row.inventoryCount;
            that.dialogExamine.formData.qualityCount = row.qualityCount;
            try {
                // 获取品控质检记录表
                const deviceDisposeList = await that.getSalesDeviceDisposeList({
                    salesOrderId: row.id,
                });
                // 这里循环质检和入库记录
                // 处理产品信息
                that.dialogExamine.products = [];
                await that.getProductList();
                row.products.forEach((p) => {
                    const pro = that.productList.find((o) => o.id == p.productInfoId);
                    const disposeList = deviceDisposeList.filter((item) => item.productTypeInfoId == pro.id);
                    const deviceCount = disposeList.reduce((a, b) => a + b.quantity, 0);
                    if (!pro)
                        return;
                    // 这里根据申请单数量生成产品总数，需要人工录入产品id，区分独立设备和包装产品
                    if (pro.category == 1) {
                        // 已处理产品数量大于所需生产数量时将不再显示
                        if (deviceCount >= p.quantity) {
                            return;
                        }
                        // 包装产品时
                        const row = {};
                        that.setProduct(pro, row);
                        row.quantity = p.quantity - deviceCount; // 数量
                        row.quantityUnit = p.quantityUnit; // 数量单位
                        row.remark = p.remark;
                        that.dialogExamine.products.push(row);
                        return;
                    }
                    // 独立产品时，设备生产数量是多少就需要有多少个设备编号录入框，但是会存在部分送检或入库的情况，所以总数需减去已送检+已入库的数量
                    // 并且需要根据设备型号去做减法，已完成送检或入库的产品将不在再次送检
                    for (let index = 0; index < p.quantity - deviceCount; index++) {
                        const row = {};
                        that.setProduct(pro, row);
                        row.quantity = 1; // 数量
                        row.quantityUnit = p.quantityUnit; // 数量单位
                        row.remark = p.remark;
                        that.dialogExamine.products.push(row);
                    }
                });
                that.formLoading = false;
            }
            catch (e) {
                that.formLoading = false;
            }
        }
        // 入库 该方法停用，生产订单里面不做入库，所有入库操作只能放到品控模块里面
        async function storeFunc() {
            that.dialogProduct.visible = true;
            that.dialogProduct.formData.storeType = '0';
            that.dialogProduct.title = '入库确认';
            that.dialogProduct.formData.inboundDate = new Date().format('yyyy-MM-dd hh:mm:ss');
            that.dialogProduct.formData.remark = `生产订单${row.orderNumber}批量入库`;
            that.dialogProduct.formData.orderId = row.id; // 订单id
            // 处理产品信息
            that.dialogProduct.products = [];
            await that.getProductList();
            row.products.forEach((p) => {
                const pro = that.productList.find((o) => o.id == p.productInfoId);
                if (!pro)
                    return;
                // 这里根据申请单数量生成产品总数，需要人工录入产品id，区分独立设备和包装产品
                if (pro.category == 1) {
                    // 包装产品时
                    var row = {};
                    that.setProduct(pro, row);
                    row.stockInOutQuantity = p.quantity; // 数量
                    row.quantityUnit = p.quantityUnit; // 数量单位
                    row.remark = p.remark;
                    that.dialogProduct.products.push(row);
                    return;
                }
                // 独立产品时
                for (let index = 0; index < p.quantity; index++) {
                    var row = {};
                    that.setProduct(pro, row);
                    row.stockInOutQuantity = 1; // 数量
                    row.quantityUnit = p.quantityUnit; // 数量单位
                    row.remark = p.remark;
                    that.dialogProduct.products.push(row);
                }
            });
        }
        async function detail() {
            await editFunc();
            that.dialogOrder.title = '查看订单详情';
        }
        // 外部添加
        async function withoutAdd() {
            that.dialogOrder.title = '新增生产申请单';
            that.dialogOrder.products = row.products || [];
        }
        that.dialogOrder.operType = operType;
        that.dialogOrder.formData = Object.assign({}, row || {});
        that.dialogOrder.products = []; // 清空产品信息
        that.formLoading = true;
        await that.initUserList();
        switch (operType) {
            case 'add':
            case 'edit':
            case 'begin':
            case 'detail':
            case 'del':
                that.dialogOrder.visible = true;
                await (operType === 'add'
                    ? addFunc()
                    : operType === 'edit'
                        ? editFunc()
                        : operType === 'begin'
                            ? beginFunc()
                            : operType === 'del'
                                ? deleteFunc()
                                : detail());
                break;
            case 'end':
            case 'store':
                await (operType === 'end' ? endFunc() : storeFunc());
                break;
            case 'withoutAdd':
                await withoutAdd();
                break;
            default:
                throw new Error(`Unsupported operType: ${operType}`);
        }
        that.formLoading = false;
    }
    /**
     * 设置产品值
     * @param productInfo
     * @param row
     */
    async setProduct(productInfo, row) {
        const that = this;
        row.productTypeInfoId = productInfo.id; // 产品id
        row.productInfo = productInfo; // 产品集合
        row.productLine = productInfo.productLine; // 产品线
        row.productType = productInfo.category; // 产品类别
        row.productTypeName = productInfo.category == 0 ? '独立设备' : '包装产品';
        row.deviceCode = ''; // 设备编号 实际
        row.productName = productInfo.productName; // 产品名称
        row.productShortName = productInfo.shortName; // 产品简称
        row.serial = productInfo.serial;
        row.model = productInfo.model;
        row.specifications = productInfo.specifications;
        row.stockInOutQuantity = 1; // 出/库数量默认为1，但是独立设备不运行修改
        row.quantityUnit = productInfo.unit;
        row.inboundType = '生产'; // 入库类型
    }
    /**
     * 获取表单禁用状态
     */
    get getFormDisabled() {
        const that = this;
        return that.dialogOrder.operType === 'begin' || that.dialogOrder.operType === 'detail' || that.dialogOrder.operType === 'end';
    }
    /**
     * 显示订单状态确认表单
     */
    async showStatusFormClick(orderStatus, row) {
        const that = this;
        const option = that.orderStatusArray.find((o) => o.value == orderStatus);
        if (!option)
            return;
        await that.initUserList();
        that.dialogStatus.title = option.label;
        that.dialogStatus.visible = true;
        that.dialogStatus.formOption = Object.assign({}, option);
        that.dialogStatus.formData = Object.assign({}, row);
        that.dialogStatus.formData.confirmDate = new Date().format('yyyy-MM-dd');
    }
    async saveOrderStatusForm() {
        const that = this;
        if (!that.$refs['refStatusForm'].validate()) {
            that.snackbar.warn('请填写必要字段后重新保存.');
            return;
        }
        // 覆盖表单原有数据
        const form = that.dialogStatus.formData;
        form[that.dialogStatus.formOption.fieldName] = form.confirmName;
        form[that.dialogStatus.formOption.fieldDate] = form.confirmDate;
        await that.axios
            .put('/api/erp/order/sales/audit/' + form.id, form)
            .then((res) => {
            that.dialogStatus.loading = false;
            // 提示成功刷新页面
            that.dialogStatus.visible = false;
            that.snackbar.success('确认订单信息成功');
            that.getDataList();
        })
            .catch((e) => {
            that.dialogStatus.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`确认订单信息错误${resMeg}`);
            console.log('确认订单信息错误', e);
        });
    }
    /**
     * 获取销售订单产品信息
     */
    async getSalesProduct(params) {
        const that = this;
        const res = await that.axios.get('/api/erp/order/sales/product', {
            params: params,
        });
        return (res.data && res.data.result) || [];
    }
    /**
     * 保存订单表单
     */
    async saveOrderForm() {
        const that = this;
        if (!(that.dialogOrder.operType === 'del')) {
            // 一定要关联产品
            if ((that.dialogOrder.products || []).length === 0) {
                that.snackbar.warn('未关联产品，请先关联产品.');
                return;
            }
            if (!that.$refs['refFormPro'].validate()) {
                that.snackbar.warn('请填写必要字段后重新保存.');
                return;
            }
        }
        const form = {
            ...that.dialogOrder.formData,
            products: that.dialogOrder.products || [],
        };
        let month = '';
        let url = '/api/erp/order/sales';
        let msg = '';
        // 添加
        if (that.dialogOrder.operType == 'add') {
            month = 'post';
            msg = '添加';
        }
        else if (that.dialogOrder.operType == 'edit') {
            month = 'put';
            url += '/' + form.id;
            msg = '修改';
        }
        else if (that.dialogOrder.operType == 'del') {
            month = 'delete';
            url += '/' + form.id;
            msg = '删除';
        }
        else if (that.dialogOrder.operType == 'begin') {
            // 开始生产
            month = 'put';
            url += '/status/' + form.id;
            msg = '修改';
            form.orderStatus = 6; // 生产中状态
        }
        else if (that.dialogOrder.operType == 'end') {
            // 开始生产
            month = 'put';
            url += '/status/' + form.id;
            msg = '修改';
            form.orderStatus = 7; // 完成生产状态
        }
        await that.sendOrderSalesResponse({
            month: month,
            url: url,
            form: form,
            msg: msg,
        });
    }
    /**
     * 发送订单响应
     */
    async sendOrderSalesResponse(op) {
        const that = this;
        await that.axios[op.month](op.url, op.form)
            .then((res) => {
            that.dialogOrder.loading = false;
            // 提示成功刷新页面
            that.dialogOrder.visible = false;
            that.snackbar.success(`${op.msg}订单信息成功`);
            that.getDataList();
        })
            .catch((e) => {
            that.dialogOrder.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`${op.msg}订单信息错误${resMeg}`);
            console.log(`${op.msg}订单信息错误`, e);
        });
    }
    /**
     * 添加产品容器
     */
    addProductContainer() {
        const that = this;
        if (that.dialogOrder.products.length > 0) {
            // 判断是否有为空的产品容器
            if (that.dialogOrder.products.findIndex((o) => (o.productInfoId || '').length == 0) > -1) {
                that.snackbar.warn('请先填写完毕后增加产品.');
                return;
            }
        }
        that.dialogOrder.products.push({
            salesOrderId: '',
            productInfo: '',
            productInfoId: '',
            productName: '',
            model: '',
            specifications: '',
            quantity: '0',
            quantityUnit: '',
            remark: '',
        });
        // 在添加控件后滚动到底部
        that.$nextTick(() => {
            that.$refs.refFormPro.$el.scrollTop = that.$refs.refFormPro.$el.scrollHeight;
        });
    }
    /**
     * 删除产品容器
     */
    delProductContainer(index) {
        const that = this;
        that.dialogOrder.products.splice(index, 1);
    }
    /**
     * 生成订单编号
     */
    async generateOrderNo() {
        const that = this;
        const orderNumbers = (that.dialogOrder.products || []).filter((o) => o.productInfo).map((o) => o.productInfo.orderNumber) || [];
        if (orderNumbers.length == 0) {
            that.snackbar.warn('请添加产品后使用该功能.');
            return false;
        }
        let prefix;
        switch (that.dialogOrder.formData.orderType) {
            case '销售':
                prefix = 'XS';
                break;
            case '试用':
                prefix = 'CS';
                break;
            default:
                prefix = 'YF';
        }
        const pro = `${orderNumbers[0]}`;
        const yrarStr = new Date().getFullYear().toString();
        let orderNumberStr = `${prefix}-${pro}-${yrarStr}`;
        const ret = await that.axios.get('/api/erp/order/sales/quantity', {
            params: { orderNumber: orderNumberStr },
        });
        const suffix = `${(Number(ret && ret.data && ret.data.result) || 0) + 1}`.padStart(3, '0'); // 后缀查询数据库，同订单编号今年订单量，如05的订单编号在2024年已有2条记录，那么最新就是003
        orderNumberStr = `${orderNumberStr}-${suffix}`;
        that.$nextTick(() => {
            // 清空这一行
            that.$set(that.dialogOrder.formData, 'orderNumber', orderNumberStr);
        });
    }
    productFilter(item, queryText, itemText) {
        return (new RegExp(queryText.toUpperCase(), 'i').test(item['productName'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['model'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['shortName'].toUpperCase())
            || new RegExp(queryText.toUpperCase(), 'i').test(item['orderNumber'] || ''));
    }
    /**
     * 产品发生变更时
     */
    productInfoChange(row) {
        const that = this;
        // 判断是否有重复的产品
        let index = that.dialogOrder.products.findIndex((o) => o.productInfoId == row.productInfo.id);
        if (index > -1) {
            that.snackbar.warn(`添加产品重复，请直接追加【${row.productInfo.productName}】数量.`);
            that.$nextTick(() => {
                that.setProductInfo({}, row);
                // 清空这一行
                that.$set(row, 'productInfo', null);
            });
            return false;
        }
        // 判断是否跟其他产品的设备编号是否一致
        const orderNumbers = that.dialogOrder.products
            .filter((o) => o.productInfo && o.productInfo.id != row.productInfo.id)
            .map((o) => o.productInfo.orderNumber);
        // 如产品编码存在，则判断是否跟其他产品的设备编号是否一致
        if (orderNumbers && orderNumbers.length > 0) {
            index = orderNumbers.findIndex((orderNumber) => orderNumber == row.productInfo.orderNumber);
            if (index == -1) {
                that.snackbar.warn(`订单编号需要与【${orderNumbers[0]}】保持一致。`);
                that.$nextTick(() => {
                    that.setProductInfo({}, row);
                    // 清空这一行
                    that.$set(row, 'productInfo', null);
                });
                return false;
            }
        }
        that.setProductInfo(row.productInfo, row);
    }
    /**
     * 设置产品值
     * @param productInfo
     * @param row
     */
    setProductInfo(productInfo, row) {
        const that = this;
        row.productInfoId = productInfo.id;
        row.productName = productInfo.productName;
        row.model = productInfo.model;
        row.quantityUnit = productInfo.unit;
        row.specifications = productInfo.specifications;
    }
    /**
     * 保存日期时间
     * @param inputType
     */
    handleDateTimeSelection(inputType) {
        const that = this;
        const selectedDate = that.dialogProduct.formData[`${inputType}SelectedDate`];
        const selectedTime = that.dialogProduct.formData[`${inputType}SelectedTime`];
        if (selectedDate && selectedTime) {
            that.dialogProduct.formData[inputType] = `${selectedDate} ${selectedTime}:00`;
            that.dialogProduct.formData[`${inputType}Menu`] = false; // 关闭选择器菜单
        }
    }
    /**
     * 保存库存信息
     */
    async saveProductInventory() {
        const that = this;
        if (!that.$refs['refFormStore'].validate()) {
            that.snackbar.warn('请填写必要字段后重新保存.');
            return;
        }
        that.dialogProduct.loading = true;
        const forms = that.getInventoryFormInfo(that.dialogProduct.formData.storeType, that.dialogProduct.formData);
        await that.axios
            .post('/api/erp/inventory', forms)
            .then(async (res) => {
            that.dialogProduct.loading = false;
            // 提示成功刷新页面
            that.dialogProduct.visible = false;
            // 修改订单状态
            const url = '/api/erp/order/sales/status/' + that.dialogProduct.formData.orderId;
            await that.sendOrderSalesResponse({
                month: 'put',
                url: url,
                form: { orderStatus: 9 },
                msg: '入库成功，并且更新',
            });
        })
            .catch((e) => {
            that.dialogProduct.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`入库错误${resMeg}`);
            console.log('入库存错误', e);
        });
    }
    /**
     * 获取库存表单信息
     * storeType :0-入库 1-出库
     */
    getInventoryFormInfo(storeType, formData) {
        const that = this;
        if (!formData)
            return [];
        const forms = [];
        // 这里组装批量入库或出库信息
        that.dialogProduct.products.forEach((item) => {
            // 公共字段
            const data = {
                productLine: item.productLine,
                productTypeInfoId: (item.productInfo || {}).id,
                productType: item.productType,
                productName: item.productName,
                productShortName: item.productShortName,
                serial: item.serial,
                model: item.model,
                specifications: item.specifications,
                stockInOutQuantity: item.stockInOutQuantity,
                remark: formData.remark,
                deviceCode: item.deviceCode,
            };
            if (formData.id)
                data.id = formData.id;
            // 入库
            if (storeType == '0') {
                data.inboundType = item.inboundType;
                data.inboundDate = formData.inboundDate;
            }
            else {
                // 出库
                data.hospitalId = formData.hospitalId || '';
                data.salesOrderId = formData.salesOrderId || '';
                data.salesOrderType = formData.salesOrderType;
                data.salesOrderNumber = formData.salesOrderNumber;
                data.deliveryDate = formData.deliveryDate;
                data.outboundType = item.outboundType;
                data.usageLocation = formData.usageLocation;
                data.outboundDate = formData.outboundDate;
            }
            forms.push(data);
        });
        return forms;
    }
    /**
     * 跳转参数处理
     */
    async skipParams() {
        const that = this;
        const params = this.$route.params || {};
        // 存在订单状态，那么就只需处理查询
        if (params.orderStatus) {
            that.searchForm.orderStatus = params.orderStatus.split(',').map(Number);
            return;
        }
        if (params.operType == 'apply') {
            // 处理弹框显示新增生产订单
            await that.showOrderFormClick('withoutAdd', params.param);
        }
    }
    async initUserList() {
        const that = this;
        if ((that.userInfoDic.list || []).length > 0) {
            // 已查询过就不在添加
            return;
        }
        that.userInfoDic.loading = true;
        const res = await that.axios.get('/api/users/');
        that.userInfoDic.list = [];
        if (res.data && res.data.result) {
            res.data.result.filter((o) => {
                if (o.usersInfo)
                    that.userInfoDic.list.push(o.usersInfo);
            });
        }
        that.userInfoDic.loading = false;
    }
    /**
     * 排序函数
     */
    tableSort(options) {
        console.log(options);
        const that = this;
        that.searchForm.sortBy = options.prop;
        that.searchForm.sortType = options.type;
        that.searchChange();
    }
    /**
     * 保存质检申请单
     */
    async saveExamineForm() {
        const that = this;
        // 产品集合里面至少有一个设备编号不为空
        const productList = that.dialogExamine.products.filter((item) => item.deviceCode);
        if (productList.length == 0) {
            that.snackbar.warn('最少需要填写一个设备编号.');
            return false;
        }
        that.dialogExamine.loading = true;
        const formData = Object.assign({}, that.dialogExamine.formData);
        const formParams = [];
        // 组装质检申请单
        productList.forEach((item) => {
            formParams.push({
                orderNumber: `ZJ-${new Date().format('yyyyMMddhhmmss')}${Math.floor(Math.random() * 10000)}`,
                dataSource: formData.dataSource,
                salesOrderId: formData.salesOrderId,
                salesOrderType: formData.salesOrderType,
                salesOrderNumber: formData.salesOrderNumber,
                productTypeInfoId: item.productTypeInfoId,
                deviceCode: item.deviceCode,
                productName: item.productName,
                productShortName: item.productShortName,
                serial: item.serial,
                model: item.model,
                specifications: item.specifications,
                deviceRemark: item.deviceRemark,
                applicant: formData.applicant,
                applicationDate: formData.applicationDate,
                quantity: item.quantity,
                examineResult: 0,
                remark: formData.remark,
            });
        });
        await that.axios
            .post('/api/erp/order/quality', formParams)
            .then(async (res) => {
            that.dialogExamine.loading = false;
            // 提示成功刷新页面
            that.dialogExamine.visible = false;
            if (that.dialogExamine.products.length == productList.length) {
                that.snackbar.success('提交质检成功，当前生产订单已完结');
                // 更新订单状态到已完成
                await that.axios.put(`/api/erp/order/sales/status/${formData.salesOrderId}`, {
                    id: formData.salesOrderId,
                    orderStatus: 7,
                    remark: `${formData.salesOrderRemark || ''}；生产订单由于所有设备都提交质检后自动完结。`,
                });
            }
            else {
                that.snackbar.success(`提交质检成功，剩余【${that.dialogExamine.products.length - productList.length}】生产中`);
            }
            that.getDataList();
        })
            .catch((e) => {
            that.dialogExamine.loading = false;
            const resMeg = e && (e.info || e.errorInfo || e.result || e.error || e.toString());
            that.snackbar.error(`新增质检申请单错误${resMeg}`);
            console.log('新增质检申请单错误', e);
        });
    }
    /**
     * 获取质检申请单
     * @param op
     */
    async getQualityExamineList(op) {
        const that = this;
        const res = await that.axios.get('/api/erp/order/quality', {
            params: op || {},
        });
        return (res && res.data && res.data.result) || [];
    }
    /**
     * 获取生产订单设备处理集合
     */
    async getSalesDeviceDisposeList(op) {
        const that = this;
        const res = await that.axios.get('/api/erp/order/sales/device/dispose', {
            params: op || {},
        });
        return (res && res.data && res.data.result) || [];
    }
    async getOrderQualityStatistics(op) {
        const that = this;
        const res = await that.axios.get('/api/erp/order/quality/statistics', {
            params: op || {},
        });
        const data = (res && res.data && res.data.result) || {};
        that.qualityPassCount = data.noPassCount || 0;
    }
    qualityCountClick() {
        this.$router.push({
            name: 'QualityExamine',
            params: { examineResults: '2' },
        });
    }
    // 刷新函数
    async refresh() {
        const that = this;
        await that.getDataList();
        await that.getOrderQualityStatistics();
    }
    async mounted() {
        const that = this;
        that.skipParams();
        await that.getDataList();
        that.getHospitalList();
        that.getOrderQualityStatistics();
    }
};
__decorate([
    Getter
], SalesOrder.prototype, "userInfo", void 0);
SalesOrder = __decorate([
    Component({
        name: 'SalesOrder',
        components: {
            BcSnackbar,
            BcDialog,
            BcTable,
        },
    })
], SalesOrder);
export default SalesOrder;
